import { createAction } from '@reduxjs/toolkit';

import type { PopupDataState } from './types';
import { name } from './slice';

export const toggleMap = createAction(`${name}/toggleMap`);

export const setPopupData = createAction<PopupDataState>(
  `${name}/setPopupData`,
);

export const resetPopupData = createAction(`${name}/resetPopupData`);
